// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3cTNe","rightAdornment":"Header_rightAdornment__3OVYu"};